import React, { useEffect, useState } from 'react';
import { ConversationHoc, CustomSplitter } from 'components/shared';
import { TasksRightSide } from './tasks-right-side';
import { useHistory } from 'react-router';
import utils, { INTERVENTION_STATUS } from 'utils';
import "./tasks.scss";
import teamChatImageView from "assets/img/teamchat.svg";

export const TasksView = () => {

    const [taskTarget, setTaskTarget] = useState(JSON.parse(new URLSearchParams(window.location.search).get('task')));
    const history = useHistory();

    useEffect(() => {
        setTaskTarget(JSON.parse(new URLSearchParams(history.location.search).get('task')));
    }, [history.location.search]);

    const isTaskShouldBeTreated = (task) => {
        return task && (
            task.status.statusId !== INTERVENTION_STATUS.COMPLETED &&
            task.status.statusId !== INTERVENTION_STATUS.DEFFERRED &&
            task.status.statusId !== INTERVENTION_STATUS.TRANSFERRED &&
            task.status.statusId !== INTERVENTION_STATUS.INITIATED);
    }

    return (
        <>
            {(taskTarget?.interventionId && isTaskShouldBeTreated(taskTarget)) ?
                <CustomSplitter
                    splitSize={{ left: 55, size: 45 }}
                    leftContent={<ConversationHoc task={taskTarget} />}
                    rightContent={<TasksRightSide task={taskTarget} taskView />}
                /> : utils.ImagePreviewContainer(teamChatImageView, 400)
            }
        </>
    );
}
